import * as React from 'react';

interface ILessonContextType {
    lessonStartTime: Date;
    setLessonStartTime: (lessonStartTime: Date) => void;
};

const LessonInitialContext = {
    lessonStartTime: new Date(), setLessonStartTime: () => null,
};

const LessonContext = React.createContext<ILessonContextType>(LessonInitialContext);
export default LessonContext

export const LessonProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const [lessonStartTime, setLessonStartTime] = React.useState<Date>(new Date());

    // console.log("Provider lessonStartTime", lessonStartTime);

    return (
        <LessonContext.Provider value={{ lessonStartTime, setLessonStartTime }}>
            {children}
        </LessonContext.Provider>
    );
}